module.exports = __webpack_public_path__ + "img/icon-ekyc-detail-passport.57d0648.svg";